import { DeckService } from "./deck.service";

export class Deck {
  constructor(public deckService: DeckService) { }

  addTab(tab) {
    this.deckService.tabs.push(tab);
  }
}
